//
// Copyright 2024 DXOS.org
//
import { enumDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import { file_google_protobuf_empty } from "@bufbuild/protobuf/wkt";
import { file_dxos_keys } from "../keys_pb.js";
import { file_dxos_echo_object } from "./object_pb.js";
import { file_dxos_echo_indexing } from "./indexing_pb.js";
/**
 * Describes the file dxos/echo/query.proto.
 */
export const file_dxos_echo_query = /*@__PURE__*/ fileDesc("ChVkeG9zL2VjaG8vcXVlcnkucHJvdG8SD2R4b3MuZWNoby5xdWVyeSJ1CgxRdWVyeVJlcXVlc3QSFAoHcXVlcnlJZBgBIAEoCUgAiAEBEjQKCnJlYWN0aXZpdHkYAyABKA4yIC5keG9zLmVjaG8ucXVlcnkuUXVlcnlSZWFjdGl2aXR5Eg0KBXF1ZXJ5GAUgASgJQgoKCF9xdWVyeUlkIhcKBUhlYWRzEg4KBmhhc2hlcxgBIAMoCSKeAwoLUXVlcnlSZXN1bHQSCgoCaWQYASABKAkSDwoHc3BhY2VJZBgEIAEoCRIXCgpkb2N1bWVudElkGAUgASgJSACIAQESFAoHcXVldWVJZBgGIAEoCUgBiAEBEhsKDnF1ZXVlTmFtZXNwYWNlGAcgASgJSAKIAQESDAoEcmFuaxgDIAEoAhIaCg1kb2N1bWVudF9qc29uGAogASgJSAOIAQESHwoSZG9jdW1lbnRfYXV0b21lcmdlGAsgASgMSASIAQESFQoIZ3JvdXBLZXkYDCABKAlIBYgBARIXCgpncm91cENvdW50GA0gASgFSAaIAQESKwoIc3BhY2VLZXkYAiABKAsyFC5keG9zLmtleXMuUHVibGljS2V5SAeIAQFCDQoLX2RvY3VtZW50SWRCCgoIX3F1ZXVlSWRCEQoPX3F1ZXVlTmFtZXNwYWNlQhAKDl9kb2N1bWVudF9qc29uQhUKE19kb2N1bWVudF9hdXRvbWVyZ2VCCwoJX2dyb3VwS2V5Qg0KC19ncm91cENvdW50QgsKCV9zcGFjZUtleSKPAQoNUXVlcnlSZXNwb25zZRIUCgdxdWVyeUlkGAEgASgJSACIAQESLQoHcmVzdWx0cxgCIAMoCzIcLmR4b3MuZWNoby5xdWVyeS5RdWVyeVJlc3VsdBItCgdvYmplY3RzGAMgAygLMhwuZHhvcy5lY2hvLm9iamVjdC5FY2hvT2JqZWN0QgoKCF9xdWVyeUlkKi0KD1F1ZXJ5UmVhY3Rpdml0eRIMCghPTkVfU0hPVBAAEgwKCFJFQUNUSVZFEAFiBnByb3RvMw", [file_google_protobuf_empty, file_dxos_keys, file_dxos_echo_object, file_dxos_echo_indexing]);
/**
 * Describes the message dxos.echo.query.QueryRequest.
 * Use `create(QueryRequestSchema)` to create a new message.
 */
export const QueryRequestSchema = /*@__PURE__*/ messageDesc(file_dxos_echo_query, 0);
/**
 * Describes the message dxos.echo.query.Heads.
 * Use `create(HeadsSchema)` to create a new message.
 */
export const HeadsSchema = /*@__PURE__*/ messageDesc(file_dxos_echo_query, 1);
/**
 * Describes the message dxos.echo.query.QueryResult.
 * Use `create(QueryResultSchema)` to create a new message.
 */
export const QueryResultSchema = /*@__PURE__*/ messageDesc(file_dxos_echo_query, 2);
/**
 * Describes the message dxos.echo.query.QueryResponse.
 * Use `create(QueryResponseSchema)` to create a new message.
 */
export const QueryResponseSchema = /*@__PURE__*/ messageDesc(file_dxos_echo_query, 3);
/**
 * @generated from enum dxos.echo.query.QueryReactivity
 */
export var QueryReactivity;
(function (QueryReactivity) {
    /**
     * / Returns a signle result.
     *
     * @generated from enum value: ONE_SHOT = 0;
     */
    QueryReactivity[QueryReactivity["ONE_SHOT"] = 0] = "ONE_SHOT";
    /**
     * / Returns the initial result and then incremental reactive updates when the data source changes.
     *
     * @generated from enum value: REACTIVE = 1;
     */
    QueryReactivity[QueryReactivity["REACTIVE"] = 1] = "REACTIVE";
})(QueryReactivity || (QueryReactivity = {}));
/**
 * Describes the enum dxos.echo.query.QueryReactivity.
 */
export const QueryReactivitySchema = /*@__PURE__*/ enumDesc(file_dxos_echo_query, 0);
//# sourceMappingURL=query_pb.js.map